import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CategoryNotification, Notification } from './categoty-notification.model';

@Injectable({providedIn: 'root'})
export class CategoryNotificationService {
    private url: string;

    constructor(private httpClient: HttpClient) {
		this.url = 'api/rail360notification';
	}

    public getAll(): Observable<CategoryNotification[]> {
		return this.httpClient.get<CategoryNotification[]>(this.url);
	}

	public getUserCategoryNotification(userId:string): Observable<Notification[]> {
		return this.httpClient.get<Notification[]>(this.url + '/getUserCategoryNotification?userId='+ userId);
	}

	public saveUserNotificationList(userId: string, notificationList: Notification[]): Observable<any> {
		return this.httpClient.post<any>(this.url + '/saveUserNotificationList?userId=' + userId, notificationList);
	}
}